import React from "react"

const ClientsContext = React.createContext({})

const { Provider, Consumer } = ClientsContext

export { Provider, Consumer, ClientsContext }
